import { render, staticRenderFns } from "./SequenceLabelling.vue?vue&type=template&id=16559b77"
import script from "./SequenceLabelling.vue?vue&type=script&lang=js"
export * from "./SequenceLabelling.vue?vue&type=script&lang=js"
import style0 from "./SequenceLabelling.vue?vue&type=style&index=0&id=16559b77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports